import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import {
  TestOpsIcon,
  KSEIcon,
  KREIcon,
  TestCloudIcon,
  RecorderIcon,
} from '../../layout/CustomIcon';
import { OrganizationFeature } from '../../models';
import { kRELicenses, kSELicenses, recorderLicenses, testCloudLicenses } from './utils';

interface Prop {
  size: number;
}
const useStyles = makeStyles<Theme, Prop>(theme => ({
  root: props => ({
    width: theme.spacing(props.size),
    height: theme.spacing(props.size),
  }),
}));

interface ProductIconProps {
  feature: OrganizationFeature;
  size?: number;
}

const getProductIconByFeature = (feature: OrganizationFeature, classes: string) => {
  switch (true) {
    case kRELicenses.includes(feature): {
      return (<KREIcon className={classes} />);
    }
    case kSELicenses.includes(feature): {
      return <KSEIcon className={classes} />;
    }
    case testCloudLicenses.includes(feature): {
      return <TestCloudIcon className={classes} />;
    }
    case recorderLicenses.includes(feature): {
      return <RecorderIcon className={classes} />;
    }
    default: {
      return <TestOpsIcon className={classes} />;
    }
  }
};

const ProductIcon = (props: ProductIconProps) => {
  const { feature, size } = props;
  const prop = { size: size ?? 3 };
  const classes = useStyles(prop);
  return getProductIconByFeature(feature, classes.root);
};
export default ProductIcon;
